import isNil from 'lodash/isNil';

export default class Formatter {
  private static numberFormatter = new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
  });

  public static fromPercent(value: string | number | null | undefined): number | null {
    if (isNil(value)) return null;
    const parsedValue = parseFloat(value.toString().replace('%', '').replace(/,/g, ''));
    return isNaN(parsedValue) ? null : parsedValue;
  }

  public static fromCurrency(value: string | number | Date | null | undefined): number | null {
    if (isNil(value)) return null;
    const parsedValue = parseFloat(value.toString().replace('$', '').replace(/,/g, ''));
    return isNaN(parsedValue) ? null : parsedValue;
  }

  public static toCurrency(value: number | null): string | null {
    if (isNil(value)) return null;
    return this.numberFormatter.format(value);
  }

  public static fromString(value: string | number | null | undefined): number | null {
    if (isNil(value)) return null;
    return parseFloat(value.toString());
  }
}
